import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-white pt-24 sm:pt-28 pb-16 sm:pb-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="text-4xl sm:text-5xl font-extrabold mb-6 text-text-primary">Privacy Policy</h1>
          <p className="text-text-secondary mb-8">Last updated: January 2026</p>
          <div className="space-y-8 text-text-secondary">
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">1. Introduction</h2>
              <p className="leading-relaxed">Jelly Local ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">2. Information We Collect</h2>
              <p className="leading-relaxed mb-4">We collect information that you provide directly to us, including:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Name and contact information (email address, phone number)</li>
                <li>Business information (company name, industry, location)</li>
                <li>Communication preferences</li>
                <li>Payment and billing information</li>
                <li>Any other information you choose to provide</li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">3. How We Use Your Information</h2>
              <p className="leading-relaxed mb-4">We use the information we collect to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Provide, maintain, and improve our services</li>
                <li>Process your transactions and send related information</li>
                <li>Send you technical notices, updates, and support messages</li>
                <li>Respond to your comments, questions, and customer service requests</li>
                <li>Communicate with you about products, services, and events</li>
                <li>Monitor and analyze trends, usage, and activities</li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">4. Information Sharing</h2>
              <p className="leading-relaxed">We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
              <ul className="list-disc list-inside space-y-2 ml-4 mt-4">
                <li>With your consent or at your direction</li>
                <li>With service providers who perform services on our behalf</li>
                <li>To comply with legal obligations</li>
                <li>To protect our rights, privacy, safety, or property</li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">5. Data Security</h2>
              <p className="leading-relaxed">We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic storage is 100% secure.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">6. Your Rights</h2>
              <p className="leading-relaxed mb-4">You have the right to:</p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Object to processing of your information</li>
                <li>Request restriction of processing</li>
                <li>Request transfer of your information</li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">7. Cookies and Tracking</h2>
              <p className="leading-relaxed">We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">8. Changes to This Policy</h2>
              <p className="leading-relaxed">We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.</p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-text-primary mb-4">9. Contact Us</h2>
              <p className="leading-relaxed">If you have any questions about this Privacy Policy, please contact us at:</p>
              <div className="mt-4 space-y-2">
                <p>Email: support@jellylocal.com</p>
                <p>Phone: 251-243-1403</p>
              </div>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPage;